import { render, staticRenderFns } from "./TermsAndPolicies.vue?vue&type=template&id=b3fbc96c&scoped=true"
import script from "./TermsAndPolicies.vue?vue&type=script&lang=js"
export * from "./TermsAndPolicies.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPolicies.vue?vue&type=style&index=0&id=b3fbc96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fbc96c",
  null
  
)

export default component.exports